import { render, staticRenderFns } from "./enrollProjectAlready.vue?vue&type=template&id=b7966e56&scoped=true&"
import script from "./enrollProjectAlready.vue?vue&type=script&lang=js&"
export * from "./enrollProjectAlready.vue?vue&type=script&lang=js&"
import style0 from "./enrollProjectAlready.vue?vue&type=style&index=0&id=b7966e56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7966e56",
  null
  
)

export default component.exports